//import library
import "bootstrap-maxlength";

export default {
  init() {
    $("[maxlength]").maxlength({
      placement: "top",
      alwaysShow: false,
      threshold: 5,
      warningClass: "label label-success",
      limitReachedClass: "label label-danger",
      separator: ". karakteri yazıyorsunuz. Bu alan en fazla ",
      preText: "",
      postText: " karakter olabilir.",
      validate: true,
    });
  },
};
